module.exports = __webpack_public_path__ + "img/nursery5.4930f871.jpg";